import React from 'react'
import CookieConsent from 'react-cookie-consent'
import useWindowSize from 'styles/window-size'

import { Wrapper, Content, LinkItem, ButtonClose } from './index.styled'

const CookiesBanner = () => {
  const ref = React.useRef()
  const { width } = useWindowSize()

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      ref?.current?.classList?.add('show')
    }, 600)
    return () => clearTimeout(timeout)
  }, [])

  const onClose = () => {
    ref?.current?.classList?.remove('show')
  }

  return (
    <Wrapper ref={ref}>
      <CookieConsent
        location='none'
        buttonText='Accept All'
        disableStyles
        containerClasses='cookies-banner'
        buttonClasses='cookies-banner-accept-btn'
        disableButtonStyles
        buttonWrapperClasses='cookies-banner-btns'
        contentClasses='cookies-banner-content'
        expires={150}
        // debug={true}
      >
        <Content>
          {width >= 768
            ? (
              <>
                We use cookies to improve your experience. By using this website you agree to our <LinkItem to='/legal'>Cookie Policy</LinkItem>.
              </>
              )
            : (
              <>
                We use cookies. By using our site, you accept our <LinkItem to='/legal'>Cookie Policy</LinkItem>.
              </>
              )}
        </Content>
        <ButtonClose onClick={onClose} />
      </CookieConsent>
    </Wrapper>
  )
}
export default CookiesBanner
